import TooltipContainer from './TooltipContainer';

export default TooltipContainer;
